'use client';

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren, ReactNode } from 'react';
import { useIsBelowBreakpoint } from '../../../hooks/useMediaQuery';
import { cn } from '../../../utils';
import { SvgFallback } from './SvgFallback';
interface FrameProps extends PropsWithChildren {
  navBar?: ReactNode;
}

// Config for frame, shared with svg fallback
const borderSize = 10;
const borderRadius = 20;
const navbarOffsetHeight = 70;

// More material behind nav bar on mobile
const mobileBottomOverflowSize = 80;
export function Frame(t0) {
  const $ = _c(11);
  const {
    children,
    navBar
  } = t0;
  const isBelowSmallBreakpoint = useIsBelowBreakpoint(768);
  const bottomOverflowForSVG = isBelowSmallBreakpoint ? mobileBottomOverflowSize : 0;
  let t1;
  if ($[0] !== navBar) {
    t1 = <header className="fixed top-0 left-0 z-40 h-[var(--navbar-offset-height)] w-full">{navBar}</header>;
    $[0] = navBar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <main className="bg-background z-1 flex min-h-screen justify-center">{children}</main>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("hidden md:block");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== bottomOverflowForSVG) {
    t4 = <div className={t3}><SvgFallback top={navbarOffsetHeight} left={borderSize} right={borderSize} bottom={borderSize} borderRadius={borderRadius} bottomOverflow={bottomOverflowForSVG} /></div>;
    $[5] = bottomOverflowForSVG;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t4) {
    t5 = <>{t1}{t2}{t4}</>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}